import {
  CopyOutlineIcon,
  DeleteOutlineIcon,
  DuplicateOutlineIcon,
  EditIcon,
  GlobalIcon,
  HideOutlineIcon,
  type IconProps,
  LockIcon,
  LockOpenedIcon,
  RevertOutlineIcon,
  ShowOutlineIcon,
  VariableIcon,
} from '@carboncopyco/icons';
import { useFlags } from 'launchdarkly-react-client-sdk'; // Import your icon components

export type DropdownItemType =
  | 'edit'
  | 'duplicate'
  | 'copy'
  | 'delete'
  | 'variable'
  | 'lock'
  | 'unlock'
  | 'revert'
  | 'show'
  | 'hide'
  | 'makeGlobalRule'
  | 'deactivate';

const useDropdownItemsConfig = (): Record<
  DropdownItemType,
  {
    label: string;
    icon?: React.ElementType<IconProps>;
    visible?: boolean;
  }
> => {
  const flags = useFlags();

  // Define the dropdown items configuration
  return {
    edit: {
      label: 'Edit',
      icon: EditIcon,
    },
    duplicate: {
      label: 'Duplicate',
      icon: DuplicateOutlineIcon,
    },
    copy: {
      label: 'Copy',
      icon: CopyOutlineIcon,
    },
    delete: {
      label: 'Delete',
      icon: DeleteOutlineIcon,
    },
    variable: {
      label: 'Use variable',
      icon: VariableIcon,
    },
    lock: {
      label: 'Lock',
      icon: LockIcon,
    },
    unlock: {
      label: 'Unlock',
      icon: LockOpenedIcon,
    },
    revert: {
      label: 'Revert all edits',
      icon: RevertOutlineIcon,
    },
    show: {
      label: 'Show',
      icon: ShowOutlineIcon,
    },
    hide: {
      label: 'Hide',
      icon: HideOutlineIcon,
    },
    makeGlobalRule: {
      label: 'Set as global edit',
      icon: GlobalIcon,
      visible: true,
    },
    deactivate: {
      label: 'Deactivate',
    },
  };
};

export default useDropdownItemsConfig;
